import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$9 } from './p-BbTg3Car.js';
import { d as defineCustomElement$8 } from './p-z4UJ58j1.js';
import { d as defineCustomElement$7 } from './p-C9_XXP_a.js';
import { d as defineCustomElement$6 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$5 } from './p-BtEI0Sh2.js';
import { d as defineCustomElement$4 } from './p-CssqlikZ.js';
import { d as defineCustomElement$3 } from './p-CFAyJ2yW.js';
import { d as defineCustomElement$2 } from './p-ClSUnmWE.js';

const expandableTileCss = ".header-wrapper{align-items:center;background:none;border:none;color:inherit;cursor:pointer;display:inline-flex;font-size:inherit;justify-content:flex-start;margin:0;padding:0;width:100%}.header-wrapper:disabled{cursor:not-allowed}.header-addon-wrapper{display:flex;gap:.5rem}:host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host header{align-items:center;background:var(--jw-theme-surface-tile-bg-color);border-radius:.375rem;display:flex;justify-content:space-between;padding:1.5rem;width:100%}:host .body-container{background-color:var(--jw-theme-surface-tile-bg-color);display:none;flex-direction:column;padding:1.5rem}:host .footer-container{padding-top:1rem}:host h3{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0}:host h4{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1rem;font-weight:600;letter-spacing:-.0008em;line-height:1.5rem;margin:0}:host .property-slots-container{display:flex;gap:1rem}:host .property-slots-chevron-group{align-items:center;display:flex;gap:1rem}:host .property-slot{align-items:center;color:var(--jw-theme-surface-text-description-color);display:flex}:host .tile-content{background-color:var(--jw-theme-surface-tile-bg-color)}:host .content{display:flex;flex-direction:column;gap:1.5rem}:host([expanded]) .body-container{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem;display:flex}:host([expanded]) header{border-bottom:1px solid var(--jw-theme-surface-border-border-color);border-bottom-left-radius:0;border-bottom-right-radius:0}:host([nested]) header{background:var(--jw-theme-surface-level1-default-bg-color)}:host([nested]) .body-container{background-color:var(--jw-theme-surface-level1-default-bg-color);border-radius:.375rem}:host([nested]) .body-container,:host([nested]) .footer-container,:host([nested]) .tile-content{background-color:var(--jw-theme-surface-level1-default-bg-color)}";

const WuiExpandableTile$1 = /*@__PURE__*/ proxyCustomElement(class WuiExpandableTile extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.expandedChange = createEvent(this, "expandedChange", 7);
        /**
         * Expandable header title
         */
        this.header = '';
        /**
         * Array of Property Slots. These can either be a String to display or a WuiStatus object
         */
        this.propertySlots = [];
        this.nested = false;
        this.expanded = false;
        this.disabled = false;
        this.toggleExpanded = () => {
            if (this.disabled) {
                return;
            }
            this.expanded = !this.expanded;
            this.expandedChange.emit(this.expanded);
        };
        this.renderPropertySlot = (propertySlot) => {
            if (propertySlot === null || propertySlot === undefined || propertySlot === '') {
                return null;
            }
            if (typeof propertySlot === 'string') {
                return h("span", { class: "property-slot" }, propertySlot);
            }
            return h("wui-status", { ...propertySlot });
        };
        this.hasFooter = () => {
            return this.elm.querySelector('[slot="footer"]') !== null;
        };
    }
    render() {
        const slotsWithDividers = [];
        const defaultBoxProps = {
            padding: 0,
        };
        const boxProps = typeof this.contentBox === 'object' ? this.contentBox : {};
        this.propertySlots.forEach((propertySlot, index) => {
            slotsWithDividers.push(this.renderPropertySlot(propertySlot));
            if (index !== this.propertySlots.length - 1) {
                slotsWithDividers.push(h("wui-divider", { type: "vertical" }));
            }
        });
        return (h(Host, { key: 'e702bc31735ba857d5fe8de825e3856df64b97f7' }, h("button", { key: 'a75fd66f008c8602b9552ffcf0543325d901b1e0', type: "button", class: "header-wrapper", disabled: this.disabled, onClick: this.toggleExpanded }, h("header", { key: 'ccd88d534c87efa90dfd8f90e9f80c94ca75065c' }, h("div", { key: '3b32e7b4fee4244a3c9a4a9363a17fe2a91e4385', class: "header-addon-wrapper" }, this.nested ? h("h4", null, this.header) : h("h3", null, this.header), h("slot", { key: 'b4559d17b36d6a48c72f63f0240b5da7bc1eae86', name: "header-addon" })), h("div", { key: '68b11c0ccc4627a2c22afcaa2210ca2981128eb3', class: "property-slots-chevron-group" }, h("div", { key: '6045d1c7943d39d45d3a96b976f490ff215cd4a1', class: "property-slots-container" }, slotsWithDividers), h("wui-button", { key: 'ca0d00c152a567dfaca14eb9eed4c5e549fccb81', type: "icon-ghost", icon: this.expanded ? 'chevron-up' : 'chevron-down', tooltip: this.expanded ? 'Collapse' : 'Expand', disabled: this.disabled })))), h("div", { key: 'a767b78f2fb9321c52ff57f558e021666935d9c1', class: "body-container" }, h("div", { key: '5ab0206ba165b8be9d1a4f61c450045d4ce72f2b', class: "content" }, h("wui-box", { key: '9bc40524db84cc4b70282c29698b54a92faf641e', style: { flex: '1' }, ...defaultBoxProps, ...(this.expanded ? boxProps : { ...boxProps, padding: 0 }) }, h("slot", { key: '33d80c853bb456fc2f327a06939d55f339b31918' })), this.hasFooter() && h("wui-divider", { key: '97fd6a395bcf4cf97e2136ac3ec99e8ebc242724', type: "horizontal" })), this.hasFooter() && (h("div", { key: '12fabeb2db8d835d606ed912124ddec1e130f033', class: "footer-container" }, h("slot", { key: '6260db6a59695715618e74e441508418add38153', name: "footer" }))))));
    }
    get elm() { return this; }
    static get style() { return expandableTileCss; }
}, [257, "wui-expandable-tile", {
        "contentBox": [4, "content-box"],
        "header": [1],
        "propertySlots": [16, "property-slots"],
        "nested": [516],
        "expanded": [1540],
        "disabled": [516]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-expandable-tile", "wui-box", "wui-button", "wui-divider", "wui-icon", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-expandable-tile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiExpandableTile$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiExpandableTile = WuiExpandableTile$1;
const defineCustomElement = defineCustomElement$1;

export { WuiExpandableTile, defineCustomElement };
